export default __webpack_public_path__ + "static/media/laundroLogo.ee61dc02.png";